export const CUSTOMER_TOKEN = 'CUSTOMER_TOKEN';
export const AUTHENTICATED = 'AUTHENTICATED';
export const CUSTOMER_ID = 'CUSTOMER_ID';
export const CUSTOMER_NAME = 'CUSTOMER_NAME';
